<template>
    <div>

        <b-form-group  class="text-center form mt-4">
            <!-- <label >Ingrese el código del lugar de estacionamiento de destino</label> -->

            <div class="form-group">
                <label>Depósito</label>
                <select class="form-control" v-model="depositId" @change="reset">
                    <option value="1">Fiscal</option>
                    <option value="2">Nacional</option>
                </select>
            </div>
            <div class="parking-input mt-2">

                <input class="form-control" v-model="findString" @keydown="status = null; value = null " @keyup="changed()" >

                <div class="btn" @click="find()" :class="[ status=='FREE' ? 'btn-success' : 'btn-light']">
                    
                    <span v-if="!loading && status!='FREE'">COMPROBAR DISPONIBILIDAD</span>
                    
                    <span v-if="loading">
                        COMPROBANDO <i class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                    </span>
                    
                    <span v-if="!loading && status=='FREE'">
                        DISPONIBLE <i class="fa fa-check"></i>
                    </span>

                </div>

            </div>
            <div class="alert alert-warning mt-4 text-center" v-if="!loading && status=='OCCUPIED'">
                El lugar {{value.code}} se encuentra ocupado, si desea reemplazar el vehículo actual continúe con el proceso. 
            </div>
            
            <div class="alert alert-warning mt-4 text-center" v-if="!loading && status=='NOT_FOUND' ">
                No se ha encontrado un lugar de estacionamiento con el código ingresado
            </div>
        </b-form-group>


    </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
    name: "ParkingSlotInput",
    props:{
        value:{
            type: Object,
            default: () => ({})
        },
        carId:{
            type: String,
            default: null
        },
    },
    data(){
        return{
            loading: false,
            status: null,
            parking_slot: null,
            findString: null,
            depositId: 2
        }
    },
    methods:{
        reset(){
            this.status = null
            this.value = null
            this.findString = null
            this.changed()
        },
        changed(){
            this.$emit('input', this.value)
        },
        find(){
            if(this.findString && this.depositId>0){
                this.loading = true
                this.parking_slot = null
                this.not_found=false
                return this.$apollo.query({
                    query: gql`query ($code: String!, $depositId: ID!, $carId: Int) {
                        parking_slot_available(code: $code, depositId: $depositId, carId: $carId) {
                            id
                            code
                            deposit{
                                id
                                title
                            }
                            multiple
                            status
                            cars{
                                chassis_number
                            }
                        }
                    }`,
                    variables: {
                        code: this.findString,
                        depositId: this.depositId,
                        carId: this.carId,
                    },
                    fetchPolicy: 'no-cache'
                })
                .then((data) => {
                    this.parking_slot = data.data.parking_slot_available;
                    this.loading = false
                    if(!this.parking_slot){
                        this.status='NOT_FOUND'
                    }else{
                        this.value = this.parking_slot
                        this.status=this.parking_slot.status
                        this.changed()
                    }
                });
            }
		},
    }

}
</script>

<style lang="scss">
.form{
    width:100%;
    max-width: 400px;
    margin: auto;
}
.parking-input{
    margin:auto;
    height: 78px;
    width:100%;
    position: relative;
    border-radius: 2px;
    display: flex;
    border: 1px solid #ced4da;
    background-color: #fff;

    input{
        border: none;
        text-align: center;
        font-size: 2rem;
        text-transform: uppercase;
        height: 76px;
    }
    .btn{
        width:140px;
        height: 64px;
        margin: 6px;
        font-size: .8rem;
        flex-grow: 0;
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

.status{
    right:16px;
}
</style>